/**
 * Object <-> row-list mapping for editing string maps (template_vars,
 * translation values) with antd Form.List.
 */
export interface KeyValueRow {
  key?: string;
  value?: string;
}

export function objectToRows(
  map?: Record<string, string> | null,
): KeyValueRow[] {
  return Object.entries(map || {}).map(([key, value]) => ({ key, value }));
}

export function rowsToObject(
  rows?: KeyValueRow[] | null,
): Record<string, string> {
  const map: Record<string, string> = {};
  for (const row of rows || []) {
    if (row?.key) map[row.key] = row.value ?? '';
  }
  return map;
}
